import { styled } from 'styled-components'

import { Cover } from '@/lib/mixins'

export const InactivityWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  z-index: 10000;
`
export const InactivityBackdrop = styled.div`
  ${Cover()}
  background-color: rgba(0,0,0,0.95);
`

export const InactivityCounter = styled.div`
  font-family: ${props => props.theme.font.primary};
  font-weight: 600;
  text-align: center;
  font-size: 400px;
  line-height: 440px;
  opacity: 0.1;
`
export const InactivityMessage = styled.div`
  font-family: ${props => props.theme.font.primary};
  text-align: center;
  font-size: 24px;
`
